import { AcresFeature } from '@/models/features';
import {
  isCompFeature,
  isCourthouseCompFeature,
  isInternalCompFeature,
  isParcelFeature,
  isRealEstateFeature,
  isSaveFeature,
} from '@/models/features/guards';
import { nFormatter, numberWithCommas } from '@/utils/common';
import { getCompFeatureAcres } from '@/utils/comps';
import getAcres from '@/utils/getAcres';
import { getParcelAcres } from '@/utils/getParcelAcres';
import { isDefined } from '@/utils/guards';

export const getAcresOfFeature = (feature: AcresFeature) => {
  if (
    isInternalCompFeature(feature) ||
    isCourthouseCompFeature(feature) ||
    isCompFeature(feature)
  ) {
    return getCompFeatureAcres(feature);
  }
  if (isRealEstateFeature(feature)) {
    return Number(feature.properties.total_acres);
  }
  if (isParcelFeature(feature)) {
    return getParcelAcres(feature);
  }

  if (isSaveFeature(feature)) {
    if (isDefined(feature.properties?.acres)) {
      return Number(feature.properties.acres);
    }

    if (isDefined(feature.parcel_data?.acres)) {
      return Number(feature.parcel_data.acres);
    }

    return getAcres(feature);
  }

  return getAcres(feature);
};

export const getAcresOfFeatures = (features: AcresFeature[]): number => {
  if (!features) return 0;

  return features.reduce((totalAcres, feature) => {
    return totalAcres + getAcresOfFeature(feature);
  }, 0);
};

export const formatAcres = (
  acres: number,
  shouldDisplayK: boolean = true,
  precision: number = 2
): string => {
  const formattedAcres = nFormatter(acres, precision, shouldDisplayK);

  // nFormatted goes to "1.00M" for millions
  if (formattedAcres.includes('M') || formattedAcres.includes('k')) {
    return formattedAcres;
  }
  return numberWithCommas(formattedAcres, true, precision);
};
